import Button from '../../../components/base/Button';

export default function RentalsHeroSection() {
  return (
    <section className="relative py-32 bg-gradient-to-br from-blue-50 via-white to-emerald-50 overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(59, 130, 246, 0.1)), url('https://public.readdy.ai/ai/img_res/b21db7f7206f9555185b122e7254c78a.jpg')`
        }}
      ></div>

      {/* Bright overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-white/80 to-white/60"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          <div className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-emerald-500 to-blue-500 text-white rounded-full text-sm font-semibold mb-8 shadow-lg">
            <i className="ri-home-heart-fill mr-2"></i>
            Premium Vacation Rentals
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6">
            Our Airbnb Properties
          </h1>
          
          <p className="text-xl text-slate-600 max-w-3xl mx-auto mb-12 leading-relaxed">
            Experience the quality and hospitality that has earned us Super Host status. Browse our carefully curated collection of premium vacation rentals across multiple destinations.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <Button size="lg" className="bg-gradient-to-r from-emerald-500 to-blue-500 text-white hover:from-emerald-600 hover:to-blue-600 font-bold shadow-xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer">
              <i className="ri-calendar-check-fill mr-2"></i>
              Book Your Stay
            </Button>
            <Button size="lg" variant="outline" className="border-2 border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white shadow-xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer">
              <i className="ri-star-fill mr-2 text-yellow-500"></i>
              Read Reviews
            </Button>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap justify-center items-center gap-8 mt-16 pt-8 border-t border-slate-200">
            <div className="flex items-center text-slate-700 bg-white/80 backdrop-blur-sm px-6 py-3 rounded-full shadow-lg">
              <i className="ri-shield-check-fill text-emerald-500 mr-2 text-xl"></i>
              <span className="font-semibold">99% Super Host Rate</span>
            </div>
            <div className="flex items-center text-slate-700 bg-white/80 backdrop-blur-sm px-6 py-3 rounded-full shadow-lg">
              <i className="ri-home-2-fill text-blue-500 mr-2 text-xl"></i>
              <span className="font-semibold">11 Active Rentals</span>
            </div>
            <div className="flex items-center text-slate-700 bg-white/80 backdrop-blur-sm px-6 py-3 rounded-full shadow-lg">
              <i className="ri-calendar-check-fill text-emerald-500 mr-2 text-xl"></i>
              <span className="font-semibold">13 Years Experience</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}